import { uniqBy } from 'lodash';
import PropTypes from 'prop-types';
import React, { useEffect } from 'react';

const RECENT_ALERT_IDS = '__RECENT_ALERT_IDS__';

const setItem = data =>
  localStorage.setItem(RECENT_ALERT_IDS, JSON.stringify(data));

const getItem = () => {
  let data = [];
  try {
    data = JSON.parse(localStorage.getItem(RECENT_ALERT_IDS));
  } catch (e) {
    console.error('Could not parse localStorage for recent alert IDs', e);
  }

  return data;
};

const handleStoreAlert = (id, status) => {
  if (id === '' || !Number.isInteger(status)) return;
  const existingAlerts = getItem() || [];
  existingAlerts.unshift({ id, status });
  const newList = uniqBy(existingAlerts, 'id');
  setItem(newList);
};

const LocalStoreAlert = ({ id, decision }) => {
  useEffect(() => handleStoreAlert(id, decision), []);

  return <span></span>;
};

LocalStoreAlert.propTypes = {
  id: PropTypes.string.isRequired,
  decision: PropTypes.number.isRequired,
};

LocalStoreAlert.displayName = 'LocalStoreAlert';

export default LocalStoreAlert;
